import React from 'react';
import i18n from '@i18n';
import './FooterPartners.less';
import { FooterPartnersList } from 'nike-ui/src/components/footer/components/FooterPartners';

const FooterPartnerLogos = () => (
    <div className="footerPartnerLogos">
        <div className="partners-title text-center">
            <span>{i18n('footer.partners')}</span>
        </div>
        <div className="text-center">
            <FooterPartnersList imgHeight="40px" className={'partners-icon'} />
        </div>
    </div>
);

export default FooterPartnerLogos;
